import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import DataTable from './datatable';

import PageSubHeader from '../../pagesubheader'
import ContainerHeader from '../../../components/ContainerHeader/index';
import * as userdetails from '../../../actions/userdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

class UserList extends Component {

    constructor(props) {
        super(props)
        // console.log('this.props.loginUser.data', this.props)
        this.state = {
            setValue: false,
            committee_id: Number(this.props.loginUser.data.committee_id ? this.props.loginUser.data.committee_id : 0),
            filterText: '',
        }
    }

    handleChange(e) {
        // this.setState({ [name]: event.target.value });
        this.setState({ committee_id: e.target.value });
    };

    handleChangeTeam(e) {
        // console.log('handleChangeTeam')
        this.setState({ committee_id: Number(e.target.value) })
        this.props.loginUser.data.committee_id = e.target.value;
        // console.log('this.props.loginUser.data',this.props.loginUser.data)
        this.props.actions.getUserDetailsList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    componentDidMount() {
        // console.log('componentDidMount')
        // console.log('props', this.props)
        this.state.setValue = false;
        this.props.actions.getUserDetailsList(this.props.loginUser.data.committee_id);
        this.props.actions.loadswitchercommittees();
    }

    handleUserInput(filterText) {
        this.setState({ filterText: filterText });
    };
    render() {
        const { userDetails, teamDetails, match, loginUser } = this.props;
        //console.log('loginUser',loginUser);
        const committeeList = teamDetails.switchteamdetailsList;
        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('this.state.setValue', this.state.setValue);
        if ((userDetails && userDetails.Status) || (userDetails && userDetails.actionStatus)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (userDetails && userDetails.UserdetailsList && userDetails.UserdetailsList.length > 0) {
            console.log('data fetched', userDetails.UserdetailsList)
            this.state.setValue = true;
            dataList = userDetails.UserdetailsList.map((_data, index) => {
                // return (<TableCell key={index} data={_data} index={index} committee_id={this.state.committee_id} loggedinUserRole_id={loginUser.data.role_id} />);
            })
        }

        let _TeamList = null
        if (committeeList && committeeList.length > 0) {
            // console.log('AddRole TeamList', committeeList)
            // _TeamList = committeeList.map(team => (
            //     <MenuItem key={team.id} value={team.id}
            //         style={{ fontWeight: '500' }}>
            //         {team.name}
            //     </MenuItem>
            // ))
            // _TeamList.unshift(<MenuItem key='0' value={0} style={{ fontWeight: '500' }}>All Team</MenuItem>)
        }
        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="User List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <PageSubHeader committee_id={this.state.committee_id} handleChangeTeam={this.handleChangeTeam.bind(this)}
                            teamDetails={teamDetails} 
                            onUserInput={this.handleUserInput.bind(this)} />

                        <div className="row">
                            <div className="col-12">
                                <DataTable data={userDetails && userDetails.UserdetailsList && userDetails.UserdetailsList.length > 0 ? userDetails.UserdetailsList : null}
                                    committee_id={this.state.committee_id} loggedinUserRole_id={loginUser.data.role_id} grantEnabled ={loginUser.grantEnabled ? loginUser.grantEnabled:false}
                                    filterText={this.state.filterText} />
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { userDetails, teamDetails, loginUser } = state
    const { match } = ownProps
    return { userDetails, teamDetails, match, loginUser }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userdetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(UserList);



// WEBPACK FOOTER //
// ./app/userdetails/userlist/index.js